// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingPage_container__33DTu","loader":"LoadingPage_loader__3aZDD","loading":"LoadingPage_loading__1Hjce"};